import { render, staticRenderFns } from "./LocalSale.vue?vue&type=template&id=ce51de08&scoped=true&"
import script from "./LocalSale.vue?vue&type=script&lang=js&"
export * from "./LocalSale.vue?vue&type=script&lang=js&"
import style0 from "./LocalSale.vue?vue&type=style&index=0&id=ce51de08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce51de08",
  null
  
)

export default component.exports